import { Dimensions, Platform } from 'react-native';
export const screenHeight = Dimensions.get('window').height;
export const screenWidth = Dimensions.get('window').width;
export const trueHundredHeight = Platform.OS === 'web' ? '100vh' : '100%';
export const trueHundredWidth = Platform.OS === 'web' ? '100vw' : '100%';
export default { screenHeight, screenWidth, trueHundredHeight, trueHundredWidth };
//# sourceMappingURL=dimensions.js.map